import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getHistorical = (ticket_id, filters, token) =>
    axios({
        method: 'get',
        url: `${api}/tickets/${ticket_id}/histories?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            notCachedResponse: true
        }
    });
